export const generalRegexp = /^([\p{L} .@_-])+$/gu
export const fullRegexp = /^([\p{L}\p{N}\p{S}\p{P}\p{Z}])+$/gu
export const emailRegexp = /^([A-Za-z0-9._-])+@([A-Za-z0-9._-])+\.([A-Za-z]{2,63})$/gu

export const userPasswordRegexp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).+$/g

export const envelopeBoxGuestEmail = {
  MAX: 150
}

export const envelopeComment = {
  MIN: 1,
  MAX: 2000
}

export const envelopeSignerFullName = {
  MIN: 1,
  MAX: 100
}

export const envelopeSignerInitials = {
  MIN: 1,
  MAX: 50
}

export const envelopeSignerPosition = {
  MAX: 100
}

export const envelopeSubject = {
  MIN: 1,
  MAX: 998
}

export const registerEmailLength = {
  MAX: 150
}

export const registerFirstNameLength = {
  MIN: 1,
  MAX: 50
}

export const registerFullNameLength = {
  MIN: 1,
  MAX: 100
}

export const registerLastNameLength = {
  MIN: 1,
  MAX: 50
}

export const registerMiddleNameLength = {
  MIN: 1,
  MAX: 50
}

export const UserPasswordLength = {
  MIN: 8,
  MAX: 50
}

export const UserLastName = {
  MIN: 1,
  MAX: 50
}

export const UserFirstName = {
  MIN: 1,
  MAX: 50
}

export const UserMiddleName = {
  MIN: 1,
  MAX: 50
}

export const UserFullName = {
  MIN: 1,
  MAX: 100
}

export const UserInitials = {
  MIN: 1,
  MAX: 50
}

export const UserCompanyName = {
  MIN: 4,
  MAX: 2000
}

export const UserCompanyZip = {
  MIN: 1,
  MAX: 50
}

export const UserCompanyAddress = {
  MIN: 4,
  MAX: 1000
}

export const UserCompanyPosition = {
  MAX: 100
}
